import R from 'ramda';
import { createSelector } from 'reselect';
import deprecated from '../deprecated.js';

import { param } from './utils';

// (root) => root.terms
const termStoreRoot = root => root.terms;

// (root) => root.terms.terms
const termsTree = createSelector(
    termStoreRoot,
    state => state.terms
);

// (root) => [ ...terms ]
export const allTerms = createSelector(
    termsTree,
    terms => R.values(terms)
);

// (root) => term
export const getLatestTerm = (function() {
    const lastTerm = (memo, next) => {
        if (new Date(next.start_date) > new Date(memo.start_date)) {
            return next;
        }
        return memo;
    };

    return createSelector(
        allTerms,
        R.reduce(lastTerm, { start_date: 0 })
    );
})();

// (root, id) => term
export const selectTerm = createSelector(
    termsTree,
    param(1),
    (terms, id) => {
        return terms[id];
    }
);

export const selectCurrentTerm = function(state) {
    if (state.currentTerm) {
        return selectTerm(state, state.currentTerm);
    }

    return getLatestTerm(state);
};

// (root) => [ ...ids ]
export const userTermIds = createSelector(
    termStoreRoot,
    state => state.user_terms
);

// (root) => [ ...terms ]
export const selectSortedTerms = createSelector(
    allTerms,
    terms =>
        terms.sort((a, b) => {
            // This sorts the newest term first
            return new Date(b.start_date) - new Date(a.start_date);
        })
);
export const sortedTerms = deprecated(
    selectSortedTerms,
    `use selectSortedTerms instead`
);



// WEBPACK FOOTER //
// ./src/selectors/terms.js